import React, { useState } from 'react';
import {
  FaBoxes,
  FaWarehouse,
  FaClipboardList,
  FaChartBar,
  FaCog,
  FaHome,
  FaTruck,
  FaGlobe,
} from 'react-icons/fa';
import { useLang } from '../i18n/LangContext';
import '../styles/Sidebar.css';

const Sidebar = ({ activeMenu, setActiveMenu }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { t, lang, toggleLang } = useLang();

  const menuItems = [
    { id: 'dashboard', name: t.sidebar.dashboard, icon: <FaHome /> },
    { id: 'materials', name: t.sidebar.materials, icon: <FaBoxes /> },
    { id: 'inventory', name: t.sidebar.inventory, icon: <FaWarehouse /> },
    { id: 'orders', name: t.sidebar.orders, icon: <FaClipboardList /> },
    { id: 'suppliers', name: t.sidebar.suppliers, icon: <FaTruck /> },
    { id: 'reports', name: t.sidebar.reports, icon: <FaChartBar /> },
    { id: 'settings', name: t.sidebar.settings, icon: <FaCog /> },
  ];

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <img src="/windyflo-logo.png" alt="WindyFlo" className="logo-img" />
          {!isCollapsed && (
            <div className="logo-text-wrap">
              <span className="logo-text">{t.app.title}</span>
              <span className="logo-sub">{t.app.subtitle}</span>
              <span className="logo-powered">{t.app.poweredBy}</span>
            </div>
          )}
        </div>
        <button
          className="collapse-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? t.sidebar.expand : t.sidebar.collapse}
        >
          {isCollapsed ? '›' : '‹'}
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
                onClick={() => setActiveMenu(item.id)}
                title={isCollapsed ? item.name : ''}
              >
                <span className="nav-icon">{item.icon}</span>
                {!isCollapsed && <span className="nav-text">{item.name}</span>}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        {/* 언어 전환 버튼 */}
        <button className="lang-toggle-btn" onClick={toggleLang} title={lang === 'ko' ? '日本語に切替' : '한국어로 전환'}>
          <FaGlobe className="lang-icon" />
          {!isCollapsed && (
            <span className="lang-label">{lang === 'ko' ? '🇯🇵 日本語' : '🇰🇷 한국어'}</span>
          )}
        </button>

        {!isCollapsed && (
          <div className="user-info">
            <div className="user-avatar">{lang === 'ko' ? '관' : '管'}</div>
            <div className="user-details">
              <div className="user-name">{t.sidebar.admin}</div>
              <div className="user-role">{t.sidebar.sysAdmin}</div>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
